if (!customElements.get('osiris-craft-film')) {
  customElements.define('osiris-craft-film', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'loop' || this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = false;
      this.visible = false;
      this.button.hidden = false;
      this.video.muted = true;
      this.video.addEventListener('playing', () => {
        this.setAttribute('data-ready', '');
        this.button.textContent = this.dataset.pause;
        if (!this.visible || document.hidden) this.video.pause();
      }, options);
      this.video.addEventListener('pause', () => { this.button.textContent = this.dataset.play; }, options);
      this.video.addEventListener('error', () => {
        this.removeAttribute('data-ready');
        this.button.textContent = this.dataset.play;
      }, options);
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.manualPause = false;
          this.play();
        } else {
          this.manualPause = true;
          this.video.pause();
        }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      }, { threshold: 0.2 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => this.update(), options);
      this.motion.addEventListener('change', () => this.update(), options);
    }
    update() {
      if (!this.visible || document.hidden || this.motion.matches || navigator.connection?.saveData) {
        this.video.pause();
      } else if (!this.manualPause) {
        this.play();
      }
    }
    play() {
      if (!this.video.getAttribute('src')) {
        this.video.src = matchMedia('(max-width:749px)').matches ? this.dataset.mobile : this.dataset.desktop;
      }
      this.video.play().catch(() => { this.button.textContent = this.dataset.play; });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.pause();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
